<template>
  <div class="Subscriber" />
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable vue/require-default-prop */

export default {
  name: "Subscriber",
  props: {
    stream: {
      type: OT.Stream,
      required: false
    },
    session: {
      type: OT.Session,
      required: false
    }
  },
  data() {
    return {
      options: {
        fitMode: "contain",
        width: "100%",
        height: "100%"
      }
    };
  },
  mounted() {
    const subscriber = this.session.subscribe(
      this.stream,
      this.$el,
      this.options,
      error => {
        if (error) {
          this.$emit("error", error);
        } else {
          this.$emit("subscriberConnected", subscriber);
        }
      }
    );
    if (subscriber) {
      subscriber.setStyle("nameDisplayMode", "off");
    }
    this.$emit("subscriberCreated", subscriber);
  }
};
</script>
<style lang="scss" scoped>
.Subscriber {
  width: 100%;
  height: 100%;
}
</style>
